export default "__VITE_ASSET__BO0Dl1yC__"